import { render, staticRenderFns } from "./AgendamentoConsulta.vue?vue&type=template&id=5e471f41&scoped=true"
import script from "./AgendamentoConsulta.vue?vue&type=script&lang=js"
export * from "./AgendamentoConsulta.vue?vue&type=script&lang=js"
import style0 from "./AgendamentoConsulta.vue?vue&type=style&index=0&id=5e471f41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e471f41",
  null
  
)

export default component.exports